export default __webpack_public_path__ + "static/media/github.4bf8f269.svg";